/**
 * Utility functions for working with entries, filters, sorts, and groups
 */

/**
 * Check if any filters are active in the Redux state
 */
export function hasActiveFilters(activeFilters) {
  if (!activeFilters) return false;

  // Check if it's an Immutable collection with a 'some' method
  if (typeof activeFilters === 'object' &&
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  typeof activeFilters.some === 'function') {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return activeFilters.some(f => f.get('active') === true);
  }
  return false;
}

/**
 * Check if any groups are active in the Redux state
 */
export function hasActiveGroups(activeGroups) {
  if (!activeGroups) return false;

  // Check if it's an Immutable collection with a 'some' method
  if (typeof activeGroups === 'object' &&
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  typeof activeGroups.some === 'function') {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return activeGroups.some(g => g.get('active') === true);
  }
  return false;
}

/**
 * Check if any sorts are active in the Redux state
 */
export function hasActiveSorts(activeSorts) {
  if (!activeSorts) return false;

  // Check if it's an Immutable collection with a 'size' property
  if (typeof activeSorts === 'object' &&
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  typeof activeSorts.size === 'number') {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return activeSorts.size > 0;
  }
  return false;
}

/**
 * Get value from a nested field path (e.g., "data.title" or "data.nested.field")
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getFieldValue(obj, fieldPath) {
  const pathParts = fieldPath.split('.');
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let value = obj;
  for (const part of pathParts) {
    value = value?.[part];
  }
  return value;
}

/**
 * Extract active filters from Immutable collection into plain array
 */

export function extractActiveFilters(activeFilters) {
  const filters = [];
  if (!activeFilters) return filters;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if (typeof activeFilters.forEach === 'function') {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    activeFilters.forEach(f => {
      if (f.get('active') === true) {
        filters.push({
          pattern: f.get('pattern'),
          field: f.get('field')
        });
      }
    });
  }
  return filters;
}

/**
 * Apply filters to an entry
 */
export function matchesFilters(entry, filters) {
  return filters.every(({
    pattern,
    field
  }) => {
    const data = ('data' in entry ? entry.data : entry) || {};
    const value = getFieldValue(data, field);
    return value !== undefined && new RegExp(String(pattern)).test(String(value));
  });
}